import TextInfo from "@/bit/components/components.text";
import FAQs from "./components/cms-faqs";
import ProductInfo from "./components/cms-product-info";
import DetailCardList from "./components/cms-detail-card-list";
import CmsAlert from "./components/cms-alert";
import CustomizerComponent from "@/bit/components/components.cms-block.cms-customizer-component";
import ImageClusterInfo from "./components/cms-image-cluster";
import ProductThumbsList from "./components/product-thumbs-list";
import CmsContainer from "./components/cms-container";
import CharacteristicsAndSteps from "./components/cms-module-characteristics-and-steps";
import CmsCustoDetailCardList from "./components/cms-custo-detail-card-list";
import CmsFilterCards from "@/bit/components/components.cms-block.cms-filter-cards";
import TextBlock from "./components/text-block";
import Characteristics from "./components/cms-characteristic-list";
import CmsPageIntro from "@/bit/components/components.cms-block.page-intro";
import CmsImageBlock from "@/bit/components/components.cms-block.image-block";
import SmallFeatureCardList from "@/bit/components/components.cms-block.cms-small-feature-list";
import NoticeBlockList from "@/bit/components/components.cms-block.cms-notice-block-list";
import CmsImageTextList from "@/bit/components/components.cms-block.cms-image-text-list";
import CmsVideoTextList from "@/bit/components/components.cms-block.cms-video-text-list";

export const COMPONENTS_MAP = {
  "cms-atom-text": TextInfo,
  "cms-module-product-info": ProductInfo,
  "cms-component-detail-card-list": DetailCardList,
  "cms-component-product-thumbs": ProductThumbsList,
  "cms-component-customizer-component": CustomizerComponent,
  "cms-component-faq-list": FAQs,
  "cms-component-filter-card-list": CmsFilterCards,
  "cms-component-image-cluster": ImageClusterInfo,
  "cms-component-custo-detail-card-list": CmsCustoDetailCardList,
  "cms-module-characteristics-and-steps": CharacteristicsAndSteps,
  "cms-component-text-block-list": TextBlock,
  "cms-component-characteristics": Characteristics,
  "cms-ml-alert": CmsAlert,
  "cms-container": CmsContainer,
  "cms-ml-page-intro": CmsPageIntro,
  "cms-component-image-block-list": CmsImageBlock,
  "cms-small-feature-card-list": SmallFeatureCardList,
  "cms-component-notice-block-list": NoticeBlockList,
  "cms-component-image-text-list": CmsImageTextList,
  "cms-component-video-text-list": CmsVideoTextList,
};

export default COMPONENTS_MAP;
